/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @license See LICENSE file distributed with this source code.
 */

import React from "react";

import { bem } from "../../../shared/BEM";
import { Link } from "react-router-dom";

/**
 * Component props
 */
export interface IButtonComponentProps {
	label?: string;
	title?: string;
	icon?: string;
	style?: "default"|"primary"|"pdf";
	size?: "default"|"large";
	width?: "auto"|"small"|"medium"|"wide";
	link?: string;
	onClick?: () => void;
}

/**
 * Button
 *
 * @param props Component props
 */
export function Button(props: IButtonComponentProps) {

	const mods = [
		"style-" + (props.style || "default"),
		"size-" + (props.size || "default"),
		"width-" + (props.width || "auto")
	];

	if (props.icon && !props.label) {
		mods.push("icon-only");
	}

	const stl = bem("button", null, mods);

	const content = <>
		{ props.icon ?
			<i className={`mdi mdi-${props.icon}`}></i>
		: null }
		{ props.label ?
		<span className={stl.el("label").str}>{props.label}</span>
		: null }
	</>;

	if (props.link) {
		return <Link to={props.link} className={stl.str} title={props.title} onClick={props.onClick}>{content}</Link>;
	} else {
		return <button className={stl.str} title={props.title} onClick={props.onClick}>{content}</button>
	}

}
